import * as pc from 'playcanvas';

/**
 * Shared loader for the rigged Mixamo character (public/character/LICENSE.txt).
 * One container fetch serves the player and every pedestrian NPC; each caller
 * gets its own animated instance.
 */

let pending: Promise<pc.Asset | null> | null = null;

function loadCharacterAsset(app: pc.Application): Promise<pc.Asset | null> {
  if (!pending) {
    pending = new Promise((resolve) => {
      const asset = new pc.Asset('character', 'container', { url: '/character/player.glb' });
      asset.once('load', () => resolve(asset));
      asset.once('error', (err: unknown) => {
        console.warn('[GOC] failed to load character:', err);
        resolve(null);
      });
      app.assets.add(asset);
      app.assets.load(asset);
    });
  }
  return pending;
}

export interface CharacterInstance {
  entity: pc.Entity;
  anim: pc.AnimComponent;
}

/** Fresh animated character instance ('walk' state assigned, playing). */
export async function spawnCharacter(app: pc.Application): Promise<CharacterInstance | null> {
  const asset = await loadCharacterAsset(app);
  if (!asset?.resource) return null;
  // `animations` exists on the runtime ContainerResource but is missing from the d.ts.
  const resource = asset.resource as pc.ContainerResource & { animations: pc.Asset[] };
  const entity = resource.instantiateRenderEntity();
  entity.addComponent('anim', { activate: true });
  const track = resource.animations[0]?.resource as pc.AnimTrack | undefined;
  if (!entity.anim || !track) return null;
  entity.anim.assignAnimation('walk', track);
  return { entity, anim: entity.anim };
}
